import {PortableText, type PortableTextProps} from '@portabletext/react';
import wysiwygComponents from './wysiwygComponents';

export interface WysiwygProps {
  value?: PortableTextProps['value'] | null;
}

export default function Wysiwyg({value}: WysiwygProps) {
  if (!value) return null;

  const normalizedValue = Array.isArray(value) ? value : [value];

  return <PortableText components={wysiwygComponents} value={normalizedValue} />;
}
